/**
 * `gallery` — a responsive image grid (module 22 D3).
 *
 * Merchant-uploaded images (spec 42 R6) in a 2/3/4-column grid; each tile
 * reserves its space via `SectionImage`, so a missing image degrades to the
 * token texture rather than a broken picture. Class-free (see `index.ts`).
 */
import { SectionImage } from "./section-image.js";
import { SectionHeading } from "./section-heading.js";

export function Gallery({
  heading,
  images,
  columns,
}: {
  heading?: string | undefined;
  images: string[];
  columns: 2 | 3 | 4;
}) {
  return (
    <section aria-label={heading ?? "Gallery"}>
      {heading ? <SectionHeading>{heading}</SectionHeading> : null}
      <div className={`flint-gallery flint-gallery-${columns}`}>
        {images.map((src, i) => (
          <SectionImage key={i} src={src} alt="" aspectRatio="1 / 1" />
        ))}
      </div>
    </section>
  );
}
